import { isApiError } from './is-api-error';
/**
 * Extracts and returns the details object from an api error.
 * Will return an empty object if not found or if not api error.
 *
 * ### Usage :
 * ```ts
 *   getApiErrorStaticCode( myError )
 * ```
 *
 */
export function getApiErrorDetails(error) {
    if (!isApiError(error))
        return {};
    return error?.response?.data?.error?.details || {};
}
//# sourceMappingURL=get-api-error-details.js.map